function calculateHeight(this: any) {
  window.scrollTo(0, this.parentElement.parentElement.offsetHeight)
}

const scrollBtn = document.getElementById('scroll-btn')
if (scrollBtn) {
  scrollBtn.addEventListener('click', calculateHeight, false)
}
